import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Center } from '@zillow/zrs-comet';
import {
    Button,
    TextButton,
    Paragraph,
    Image,
    Spacer,
    Card,
} from '@zillow/constellation';

import { RMWContext } from 'app/shared/providers/RMWContext';
import ListingActivationTerm from 'app/shared/components/ListingActivationTerms';
import SvgPeople from 'app/shared/images/people.svg';

const ApplicationsDisabledCard = ({
    displayInviteToApplyModal,
    handleEnableApplicationsClick,
    handleLearnMoreClick,
}) => {
    const { paths: { tenantScreeningPage } } = useContext(RMWContext);
    const { status } = useSelector(state => state.properties.propertyOverview);

    const enableAppCTAButtonType = status.toLowerCase() === 'off-market'
        ? 'secondary'
        : 'primary';

    return (
        <Card className="ApplicationsDisabledCard" cardType="secondary">
            <Spacer padding="md">
                <Center>
                    <Spacer paddingY="sm">
                        <Image src={SvgPeople} alt="" />
                    </Spacer>

                    <Spacer paddingY="sm">
                        <Paragraph fontType="bodyHeading">
                            Simplify your rental process
                        </Paragraph>
                    </Spacer>

                    <Paragraph>
                        Save time with Zillow’s online rental applications.
                        Access credit reports, background checks and eviction history in one place.
                    </Paragraph>

                    <Spacer paddingY="sm">
                        <TextButton
                            as="a"
                            href={tenantScreeningPage}
                            target="_blank"
                            onClick={handleLearnMoreClick}
                        >
                            Learn more
                        </TextButton>
                    </Spacer>

                    <Spacer paddingY="sm">
                        <Button
                            fluid={true}
                            buttonType={enableAppCTAButtonType}
                            onClick={handleEnableApplicationsClick}
                        >
                            Enable applications
                        </Button>
                        <Spacer marginTop="xs">
                            <Button marginBottom="xs" onClick={displayInviteToApplyModal} fluid={true}>
                                Invite to apply
                            </Button>
                        </Spacer>
                    </Spacer>

                    <ListingActivationTerm
                        lowlight={true}
                        actionText="By selecting “Enable applications” or “Invite someone to apply”"
                    />
                </Center>
            </Spacer>
        </Card>
    );
};

ApplicationsDisabledCard.propTypes = {
    displayInviteToApplyModal: PropTypes.func.isRequired,
    handleEnableApplicationsClick: PropTypes.func.isRequired,
    handleLearnMoreClick: PropTypes.func.isRequired,
};

export default ApplicationsDisabledCard;
